import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { FALLBACK_CONTENT, phoneHref } from "@/lib/data";
import Logo from "@/components/Logo";

export default function BookingConfirmation() {
  const { id } = useParams();
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState(false);
  const content = FALLBACK_CONTENT;

  useEffect(() => {
    api.get(`/bookings/${id}`).then((r) => setBooking(r.data)).catch(() => setError(true));
  }, [id]);

  return (
    <div className="bg-[#070b12] min-h-screen text-[#f0f4f8] flex flex-col" data-testid="confirmation-page">
      <header className="border-b border-[#1e9bff]/20 py-5">
        <div className="max-w-4xl mx-auto px-4">
          <Link to="/"><Logo /></Link>
        </div>
      </header>
      <main className="flex-1 flex items-center">
        <div className="max-w-2xl mx-auto px-4 py-20 w-full">
          {error ? (
            <div className="text-center">
              <h1 className="font-display uppercase text-4xl text-white mb-4">Booking Not Found</h1>
              <p className="text-sm text-[#93b4d4] mb-8">We couldn't find that reference — give us a call and we'll check for you.</p>
              <a href={phoneHref(content.phone)} data-testid="confirmation-call-btn" className="text-[#1e9bff] font-mono-lbl text-sm uppercase tracking-wider hover:underline">
                Call {content.phone}
              </a>
            </div>
          ) : !booking ? (
            <p className="text-center text-[#93b4d4] font-mono-lbl text-sm">Loading your confirmation…</p>
          ) : (
            <div className="p-8 md:p-10 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/40 shadow-[0_0_50px_rgba(30,155,255,0.15)]" data-testid="confirmation-card">
              <div className="w-14 h-14 rounded-full bg-[#1e9bff]/20 text-[#1e9bff] flex items-center justify-center text-2xl font-bold mb-6">✓</div>
              <h1 className="font-display uppercase text-3xl md:text-4xl text-white mb-2" data-testid="confirmation-heading">
                {booking.mode === "quote" ? "Quote Request Received" : "You're Booked In"}
              </h1>
              <p className="font-script text-[#9fd2ff] text-2xl mb-8">We'll see you soon, {booking.name.split(" ")[0]}!</p>
              <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm mb-8">
                {[
                  ["Reference", booking.id.slice(0, 8).toUpperCase()],
                  ["Services", booking.services.join(", ")],
                  ["Property", booking.property_type],
                  ["Date", booking.date || "To be arranged"],
                  ["Time slot", booking.slot_label || "To be arranged"],
                  ["Status", booking.status === "quote" ? "Quote requested" : "Pending confirmation"],
                ].map(([k, v]) => (
                  <div key={k} className="p-4 rounded-xl bg-[#070b12] border border-white/10">
                    <dt className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#1e9bff] mb-1">{k}</dt>
                    <dd className="text-white">{v}</dd>
                  </div>
                ))}
              </dl>
              <p className="text-xs text-[#93b4d4] mb-8" data-testid="confirmation-email-note">
                A confirmation email is on its way to <span className="text-white">{booking.email}</span>. We'll be in touch to confirm shortly — questions? Call{" "}
                <a href={phoneHref(content.phone)} className="text-[#1e9bff] hover:underline">{content.phone}</a>.
              </p>
              <Link
                to="/"
                data-testid="confirmation-home-btn"
                className="inline-block px-7 py-4 rounded-xl bg-[#1e9bff] text-black font-display uppercase tracking-wider hover:bg-[#60baff] transition-colors"
              >
                Back to Homepage
              </Link>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
